module.exports = __webpack_public_path__ + "src/assets/img/nc-bg.3567f96c.png";